import React, { useState } from "react";
import { api } from "@/lib/api";
import { renderUserAvatar } from "@/lib/avatar";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function SearchView() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const run = async (val) => {
    setQ(val);
    if (val.length < 2) { setRes([]); return; }
    const { data } = await api.get("/search/messages", { params: { q: val } });
    setRes(data);
  };
  return (
    <div className="flex-1 flex flex-col overflow-hidden bg-white">
      <div className="h-14 border-b flex items-center gap-2 px-6 shrink-0">
        <Search className="w-4 h-4 text-zinc-400"/>
        <Input value={q} onChange={(e) => run(e.target.value)} placeholder="Search messages…" className="border-0 focus-visible:ring-0" data-testid="search-input"/>
      </div>
      <div className="flex-1 overflow-auto p-6 max-w-2xl scroll-thin">
        {res.map((m) => (
          <div key={m.id} className="p-3 border rounded-lg mb-2">
            <div className="flex items-center gap-2 mb-1"><img src={renderUserAvatar(m.user)} className="w-6 h-6 rounded-full object-cover" alt=""/><span className="text-sm font-medium">{m.user?.name}</span><span className="text-xs text-zinc-400">{new Date(m.created_at).toLocaleString()}</span></div>
            <div className="text-sm">{m.text}</div>
          </div>
        ))}
        {q.length >= 2 && res.length === 0 && <div className="text-sm text-zinc-400">No matches.</div>}
      </div>
    </div>
  );
}
